import { render } from "./UploadImageModalComponent.vue?vue&type=template&id=403c87b9"
import script from "./UploadImageModalComponent.vue?vue&type=script&lang=js"
export * from "./UploadImageModalComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__